import ConditionIcons from '../components/ConditionIcons/ConditionIcons';
import {
  FaArrowDown,
  FaArrowUp,
  FaBuilding,
  FaCalendarDay,
  FaChartLine,
  FaClock,
  FaDroplet,
  FaEye,
  FaGaugeHigh,
  FaHouse,
  FaHurricane,
  FaLayerGroup,
  FaLocationDot,
  FaTemperatureArrowDown,
  FaTemperatureArrowUp,
  FaTemperatureHalf,
  FaTriangleExclamation,
  FaWater,
  FaWind,
} from 'react-icons/fa6';
import { IoMdAlert } from 'react-icons/io';
import { MdDewPoint, MdOutlineSurfing } from 'react-icons/md';
import { PiWaves, PiWavesBold, PiWind } from 'react-icons/pi';
import { WiMoonrise, WiMoonset, WiSunrise, WiSunset } from 'react-icons/wi';

export const DEFAULT_WEATHER_DETAIL_ICON_SIZE = 21;

// Every configured Weather detail uses the same contract:
// { id, label, iconKey, getValue, getIconProps? }.
export const WEATHER_DETAIL_ICON_KEYS = Object.freeze({
  AIR_QUALITY: 'airQuality',
  ALERT: 'alert',
  CATEGORY: 'category',
  COMFORT: 'comfort',
  DATE: 'date',
  DEPTH: 'depth',
  DEW_POINT: 'dewPoint',
  HIGH_TEMPERATURE: 'highTemperature',
  HUMIDITY: 'humidity',
  HURRICANE: 'hurricane',
  LOCATION: 'location',
  LOW_TEMPERATURE: 'lowTemperature',
  MAGNITUDE: 'magnitude',
  MOONRISE: 'moonrise',
  MOONSET: 'moonset',
  PRECIPITATION_PROBABILITY: 'precipitationProbability',
  PRESSURE: 'pressure',
  SENDER: 'sender',
  SEVERITY: 'severity',
  SKY_CONDITION: 'skyCondition',
  SUNRISE: 'sunrise',
  SUNSET: 'sunset',
  SURF: 'surf',
  TEMPERATURE: 'temperature',
  TIDE_HIGH: 'tideHigh',
  TIDE_LOW: 'tideLow',
  TIME: 'time',
  VISIBILITY: 'visibility',
  WATER: 'water',
  WAVE: 'wave',
  WIND_DIRECTION: 'windDirection',
  WIND_SPEED: 'windSpeed',
});

export const WEATHER_DETAIL_ICON_COMPONENTS = Object.freeze({
  [WEATHER_DETAIL_ICON_KEYS.AIR_QUALITY]: PiWavesBold,
  [WEATHER_DETAIL_ICON_KEYS.ALERT]: IoMdAlert,
  [WEATHER_DETAIL_ICON_KEYS.CATEGORY]: FaLayerGroup,
  [WEATHER_DETAIL_ICON_KEYS.COMFORT]: FaHouse,
  [WEATHER_DETAIL_ICON_KEYS.DATE]: FaCalendarDay,
  [WEATHER_DETAIL_ICON_KEYS.DEPTH]: FaArrowDown,
  [WEATHER_DETAIL_ICON_KEYS.DEW_POINT]: MdDewPoint,
  [WEATHER_DETAIL_ICON_KEYS.HIGH_TEMPERATURE]: FaTemperatureArrowUp,
  [WEATHER_DETAIL_ICON_KEYS.HUMIDITY]: FaDroplet,
  [WEATHER_DETAIL_ICON_KEYS.HURRICANE]: FaHurricane,
  [WEATHER_DETAIL_ICON_KEYS.LOCATION]: FaLocationDot,
  [WEATHER_DETAIL_ICON_KEYS.LOW_TEMPERATURE]: FaTemperatureArrowDown,
  [WEATHER_DETAIL_ICON_KEYS.MAGNITUDE]: FaChartLine,
  [WEATHER_DETAIL_ICON_KEYS.MOONRISE]: WiMoonrise,
  [WEATHER_DETAIL_ICON_KEYS.MOONSET]: WiMoonset,
  [WEATHER_DETAIL_ICON_KEYS.PRECIPITATION_PROBABILITY]: FaDroplet,
  [WEATHER_DETAIL_ICON_KEYS.PRESSURE]: FaGaugeHigh,
  [WEATHER_DETAIL_ICON_KEYS.SENDER]: FaBuilding,
  [WEATHER_DETAIL_ICON_KEYS.SEVERITY]: FaTriangleExclamation,
  [WEATHER_DETAIL_ICON_KEYS.SKY_CONDITION]: ConditionIcons,
  [WEATHER_DETAIL_ICON_KEYS.SUNRISE]: WiSunrise,
  [WEATHER_DETAIL_ICON_KEYS.SUNSET]: WiSunset,
  [WEATHER_DETAIL_ICON_KEYS.SURF]: MdOutlineSurfing,
  [WEATHER_DETAIL_ICON_KEYS.TEMPERATURE]: FaTemperatureHalf,
  [WEATHER_DETAIL_ICON_KEYS.TIDE_HIGH]: FaArrowUp,
  [WEATHER_DETAIL_ICON_KEYS.TIDE_LOW]: FaArrowDown,
  [WEATHER_DETAIL_ICON_KEYS.TIME]: FaClock,
  [WEATHER_DETAIL_ICON_KEYS.VISIBILITY]: FaEye,
  [WEATHER_DETAIL_ICON_KEYS.WATER]: FaWater,
  [WEATHER_DETAIL_ICON_KEYS.WAVE]: PiWaves,
  [WEATHER_DETAIL_ICON_KEYS.WIND_DIRECTION]: PiWind,
  [WEATHER_DETAIL_ICON_KEYS.WIND_SPEED]: FaWind,
});
